import { COLOR_INDICATORS } from '@disco/constants/FeatureTypes'
import { useFeatureEnabled } from '@disco/state-management/selectors/business'

export const useIndicatorsEnabled = (): boolean =>
  useFeatureEnabled(COLOR_INDICATORS)
